import { render, staticRenderFns } from "./ImportData.vue?vue&type=template&id=0bd798e6&scoped=true"
import script from "./ImportData.vue?vue&type=script&lang=js"
export * from "./ImportData.vue?vue&type=script&lang=js"
import style0 from "./ImportData.vue?vue&type=style&index=0&id=0bd798e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd798e6",
  null
  
)

export default component.exports